import { render, staticRenderFns } from "./TwTable.vue?vue&type=template&id=14db9c8e&scoped=true&"
import script from "./TwTable.vue?vue&type=script&lang=js&"
export * from "./TwTable.vue?vue&type=script&lang=js&"
import style0 from "./TwTable.vue?vue&type=style&index=0&id=14db9c8e&lang=less&scoped=true&"
import style1 from "./TwTable.vue?vue&type=style&index=1&id=14db9c8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db9c8e",
  null
  
)

export default component.exports